import {get} from "lodash";

export const WildCardRegExp = new RegExp(/{{([a-zA-Z0-9.]+?)}}/g)

const replace = (text: string, evaluationContext: any, removeUnknown: boolean, quoteNumbers: boolean) => {
   const matches = text?.matchAll(WildCardRegExp) || [];
   for (const match of matches) {
      let replaceWith = get(evaluationContext, match[1]);
      if (replaceWith === undefined) {
         if (removeUnknown === undefined || removeUnknown) {
            replaceWith = ''
         } else {
            replaceWith = '{{' + match[1] + '}}';
         }
      }

      if(typeof replaceWith === 'number' && quoteNumbers) {
         text = text.replace("\"" + match[0] + "\"", String(replaceWith))
      } else {
         text = text.replace(match[0], replaceWith)
      }
   }
   return text;
}

export const WildcardUtility = {
   replace
}
